type PressLogo = {
  name: string;
  src: string;
  width: number;
  height: number;
  /** A single-colour mark, which can be whitened for dark surfaces. */
  isMonochrome: boolean;
};

// The same marks the funnels' "as seen on" strips use, copied from Sanity so
// the homepage needs no new CMS fields. Dimensions are each SVG's viewBox.
const PRESS_LOGOS: PressLogo[] = [
  {
    name: 'Sky Sports',
    src: '/images/press/sky-sports.svg',
    width: 250,
    height: 54,
    isMonochrome: false
  },
  {
    name: 'The Athletic',
    src: '/images/press/the-athletic.svg',
    width: 250,
    height: 35,
    isMonochrome: true
  },
  {
    name: 'The Telegraph',
    src: '/images/press/telegraph.svg',
    width: 250,
    height: 40,
    isMonochrome: true
  }
];

const DEFAULT_LOGO_HEIGHT_PX = 16;

// A full-colour mark keeps its own colours on a dark surface: whitening it
// would also whiten the lettering knocked out of its coloured boxes.
const logoToneClasses = (
  tone: 'dark' | 'light',
  isMonochrome: boolean
): string => {
  if (tone === 'dark') return 'opacity-80 grayscale';
  return isMonochrome ? 'brightness-0 invert' : '';
};

type PressLogosProps = {
  /** "light" whitens the single-colour marks for dark surfaces. */
  tone?: 'dark' | 'light';
  logoHeight?: number;
  className?: string;
};

const PressLogos = ({
  tone = 'dark',
  logoHeight = DEFAULT_LOGO_HEIGHT_PX,
  className = ''
}: PressLogosProps) => (
  <div className={`flex flex-wrap items-center gap-x-5 gap-y-2 ${className}`}>
    <span
      className={`font-open-sans text-xs font-semibold ${
        tone === 'light' ? 'text-neutral-300' : 'text-landing-slate'
      }`}
    >
      As seen on
    </span>
    <ul className="flex flex-wrap items-center gap-x-5 gap-y-2">
      {PRESS_LOGOS.map(({ name, src, width, height, isMonochrome }) => (
        <li key={name}>
          <img
            src={src}
            alt={name}
            width={Math.round((width / height) * logoHeight)}
            height={logoHeight}
            decoding="async"
            className={logoToneClasses(tone, isMonochrome)}
          />
        </li>
      ))}
    </ul>
  </div>
);

export default PressLogos;
